export default __webpack_public_path__ + "static/media/left-arrow-long-icon.c7597fb1.svg";